import { render, staticRenderFns } from "./AlterarPrazoVencimento.vue?vue&type=template&id=5fee1a9c"
import script from "./AlterarPrazoVencimento.vue?vue&type=script&lang=js"
export * from "./AlterarPrazoVencimento.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports